import type { ScoreEntity } from '@parcel/filters';
import { Skeleton } from '@parcel/ui';
import { DATASET_BY_ENTITY, type ScorePreview } from '../../lib/scores.js';
import { BucketBadge } from './score-cells.js';

/** Four cards, top bucket first: how many records each bucket would hold with these criteria. */
export function ScoreDistribution({
  entity,
  preview,
  loading,
  buckets,
  empty,
}: {
  entity: ScoreEntity;
  preview: ScorePreview | undefined;
  loading: boolean;
  buckets: { key: string; label: string }[];
  empty: boolean;
}) {
  const total = preview?.total ?? 0;
  return (
    <div
      className="grid grid-cols-2 gap-3 lg:grid-cols-4"
      aria-busy={loading}
      data-testid="score-preview"
    >
      {buckets.map((bucket) => {
        const count = preview?.buckets.find((b) => b.key === bucket.key)?.count;
        return (
          <div key={bucket.key} className="space-y-2 rounded-lg border bg-card p-3">
            <BucketBadge
              value={{ score: 0, bucket: bucket.key, matched: [] }}
              score={{ buckets }}
            />
            {empty ? (
              <div className="text-sm text-muted-foreground">-</div>
            ) : count === undefined ? (
              loading ? (
                <Skeleton className="h-6 w-20" />
              ) : (
                <div className="text-sm text-muted-foreground">-</div>
              )
            ) : (
              <div className="flex items-baseline gap-1.5">
                <span className="text-lg font-semibold tabular-nums">
                  {count.toLocaleString('en-US')}
                </span>
                <span className="text-xs text-muted-foreground">
                  {DATASET_BY_ENTITY[entity]}
                  {total > 0 ? ` · ${Math.round((100 * count) / total)}%` : ''}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
